import { PRIVACY_LINK_PATH, TERMS_OF_USE_LINK_PATH } from 'components/Footer/constants';
import Link from 'components/Link';
import styles from './Police.module.scss';

const HEADLINE = 'By selecting Submit my application below, you acknowledge:';

const INFO =
  'By submitting your application, you certify that all information you’ve provided on this form is true and correct.';

enum Title {
  Police = 'Policies and Notices',
  Data = 'Data Authorization',
  USAActNotice = 'USA PATRIOT Act Notice',
  CreditReportInquiry = 'Credit Report Inquiry',
}

const CONSUMER_PRIVACY_POLICY_LINK_PATH =
  'https://www.sparrowcard.com/legal/consumer-privacy-policy';

const Paragraph = {
  Police: (
    <>
      I’ve received and reviewed Sparrow’s{' '}
      <Link target="_blank" href={TERMS_OF_USE_LINK_PATH}>
        Terms of Use
      </Link>
      ,{' '}
      <Link target="_blank" href={PRIVACY_LINK_PATH}>
        Privacy Policies
      </Link>
      , and{' '}
      <Link target="_blank" href={CONSUMER_PRIVACY_POLICY_LINK_PATH}>
        Consumer Privacy Notice
      </Link>
      .
    </>
  ),
  Data: 'I am providing authorization to Sparrow to use my information for its business purposes and to offer me other Sparrow products, now or in the future.',
  USAActNotice:
    'Federal law requires all financial institutions to obtain, verify and record information that identifies each person who opens an account, including your name, address, date of birth, social security number, and other information that will allow us to verify your identity. We may also ask to see your driver’s license or other identifying documents.',
  CreditReportInquiry:
    'If approved, a hard inquiry will be reflected on your credit report, which may impact your credit score. If declined, no hard inquiry will be reflected.',
};

const Police = () => {
  return (
    <div className={styles.container}>
      <h2 className={styles.headline}>{HEADLINE}</h2>
      <div className={styles.content}>
        <h3 className={styles.title}>{Title.Police}</h3>
        <p className={styles.paragraph}>{Paragraph.Police}</p>
      </div>
      <div className={styles.content}>
        <h3 className={styles.title}>{Title.Data}</h3>
        <p className={styles.paragraph}>{Paragraph.Data}</p>
      </div>
      <div className={styles.content}>
        <h3 className={styles.title}>{Title.USAActNotice}</h3>
        <p className={styles.paragraph}>{Paragraph.USAActNotice}</p>
      </div>
      <div className={styles.content}>
        <h3 className={styles.title}>{Title.CreditReportInquiry}</h3>
        <p className={styles.paragraph}>{Paragraph.CreditReportInquiry}</p>
      </div>
      <p className={styles.info}>{INFO}</p>
    </div>
  );
};

export default Police;
